/**
 * Region mapping for Gårdsförsäljning hub pages.
 * Add new regions here to auto-generate routes and sitemap entries.
 */
export interface GardforsaljningRegion {
  slug: string;
  label: string;
  /** Matches producers.region or producers.county */
  dbValues: string[];
}

export const GARDFORSALJNING_REGIONS: GardforsaljningRegion[] = [
  {
    slug: "dalarna",
    label: "Dalarna",
    dbValues: ["Dalarna", "Dalarnas län"],
  },
  {
    slug: "skane",
    label: "Skåne",
    dbValues: ["Skåne", "Skåne län"],
  },
  {
    slug: "vastmanland",
    label: "Västmanland",
    dbValues: ["Västmanland", "Västmanlands län"],
  },
  {
    slug: "gotland",
    label: "Gotland",
    dbValues: ["Gotland", "Gotlands län"],
  },
];

export function findRegionBySlug(slug: string): GardforsaljningRegion | undefined {
  return GARDFORSALJNING_REGIONS.find((r) => r.slug === slug);
}
